import React from 'react';

import { TOpsClassDetailEx } from '../../../requests/opsRegistrationsExtra';
import { btnGhost, Card, labelClass } from '../ui';
import { fieldClass, TClassForm, TSetField } from './shared';

type Props = {
  form: TClassForm;
  set: TSetField;
  isNew: boolean;
  existing?: TOpsClassDetailEx;
};

/** Learner, survey and outline links, plus the signed calendar link. */
const LinksSection: React.FC<Props> = ({ form, set, isNew, existing }) => (
  <Card title="Links">
    <div className="grid grid-cols-1 gap-4 p-5 md:grid-cols-2">
      {(
        [
          ['learnerLink', 'Learner link', 'Materials / SharePoint folder'],
          [
            'privateClassLink',
            'Private class link',
            'Invite link for the roster',
          ],
          ['studentSurvey', 'Student survey', 'Post-class survey URL'],
          [
            'instructorSurvey',
            'Instructor survey',
            'Post-class instructor survey URL',
          ],
          ['courseOutline', 'Course outline', 'Outline document URL'],
        ] as const
      ).map(([key, label, hint]) => (
        <div key={key}>
          <label className={labelClass}>{label}</label>
          <div className="flex items-center gap-2">
            <input
              type="url"
              className={fieldClass}
              placeholder={hint}
              value={form[key]}
              onChange={(e) => set(key)(e.target.value)}
            />
            {form[key] && (
              <a
                className={`${btnGhost} whitespace-nowrap`}
                href={form[key]}
                target="_blank"
                rel="noreferrer"
              >
                open
              </a>
            )}
          </div>
        </div>
      ))}
      {!isNew && existing?.links?.icalLink && (
        <div className="md:col-span-2">
          <label className={labelClass}>Calendar link (public, signed)</label>
          <div className="flex items-center gap-2 text-sm">
            <input
              readOnly
              className={`${fieldClass} text-gray-three`}
              value={existing.links.icalLink}
              onFocus={(e) => e.currentTarget.select()}
            />
            <a
              className={`${btnGhost} whitespace-nowrap`}
              href={existing.links.icalLink}
              target="_blank"
              rel="noreferrer"
            >
              open
            </a>
          </div>
          <div className="mt-1 text-xs text-gray-bold">
            Learners can open this from an email without logging in.
          </div>
        </div>
      )}
      <div className="text-xs text-gray-bold md:col-span-2">
        Links only for now — file upload comes with the document store.
      </div>
    </div>
  </Card>
);

export default LinksSection;
